import Prompt from "../components/Prompt"

export default function PromptPage() {
  return (
    <div className="font-sans">
      <Prompt/>
    </div>
  );
}
